import { hPost } from '@mcfe/tools';

// 获取供应商是否入驻
export const getCheckSupplierExistApi = () => hPost('/api/vss/second/shepherd/sqm/merchantsSupplier/checkSupplierExist');

// 获取商家账号信息
export const getBizAccountApi = (options) => hPost('/api/vss/shepherd/account/getBizAccountInfo', {}, { cache: true, ...options });
